namespace TabAurous.Production {
    export interface TreeMakingForm {
        TransId: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        TreeNo: Serenity.StringEditor;
        EmployeeId: Serenity.LookupEditor;
        UserId: Serenity.LookupEditor;
        DepartmentId: Serenity.LookupEditor;
        RMDepartmentId: Serenity.LookupEditor;
        ProcessId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        BaseWeight: Serenity.DecimalEditor;
        TreeWeight: Serenity.DecimalEditor;
        ConversionFactor: Serenity.DecimalEditor;
        ButtonWeight: Serenity.DecimalEditor;
        CurrencyId: Serenity.IntegerEditor;
        ExchRate: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        Roundoff: Serenity.DecimalEditor;
        CompanyId: Serenity.IntegerEditor;
        AddressId: Serenity.IntegerEditor;
        ShipmentId: Serenity.IntegerEditor;
        ShipAddressId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        ItemDetails: TreeMakingItemsEditor;
        StoneWeight: Serenity.DecimalEditor;
        DiamondWeight: Serenity.DecimalEditor;
        MetalRequired: Serenity.DecimalEditor;
        MetalIssued: Serenity.DecimalEditor;
        MetalConsumed: Serenity.DecimalEditor;
        MetalBalance: Serenity.DecimalEditor;
        Loss: Serenity.DecimalEditor;
        LossPercent: Serenity.DecimalEditor;
        IssueDetails: TreeMakingIssueEditor;
        ReceiptDetail: TreeMakingReceiptEditor;
        Remark: Serenity.StringEditor;
    }

    export class TreeMakingForm extends Serenity.PrefixedContext {
        static formKey = 'Production.TreeMaking';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TreeMakingForm.init)  {
                TreeMakingForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.LookupEditor;
                var w4 = s.DecimalEditor;
                var w5 = TreeMakingItemsEditor;
                var w6 = TreeMakingIssueEditor;
                var w7 = TreeMakingReceiptEditor;

                Q.initFormType(TreeMakingForm, [
                    'TransId', w0,
                    'TransDate', w1,
                    'VoucherNo', w0,
                    'VoucherTypeId', w2,
                    'TreeNo', w0,
                    'EmployeeId', w3,
                    'UserId', w3,
                    'DepartmentId', w3,
                    'RMDepartmentId', w3,
                    'ProcessId', w3,
                    'KaratId', w3,
                    'MetalColorId', w3,
                    'BaseWeight', w4,
                    'TreeWeight', w4,
                    'ConversionFactor', w4,
                    'ButtonWeight', w4,
                    'CurrencyId', w2,
                    'ExchRate', w4,
                    'NetAmount', w4,
                    'Roundoff', w4,
                    'CompanyId', w2,
                    'AddressId', w2,
                    'ShipmentId', w2,
                    'ShipAddressId', w2,
                    'FinancialYearId', w2,
                    'ItemDetails', w5,
                    'StoneWeight', w4,
                    'DiamondWeight', w4,
                    'MetalRequired', w4,
                    'MetalIssued', w4,
                    'MetalConsumed', w4,
                    'MetalBalance', w4,
                    'Loss', w4,
                    'LossPercent', w4,
                    'IssueDetails', w6,
                    'ReceiptDetail', w7,
                    'Remark', w0
                ]);
            }
        }
    }
}
